import {
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
  Area,
  ComposedChart,
} from 'recharts';

interface PriceGapDataPoint {
  time: string;
  gap: number;
  polymarket: number;
  odds: number;
  timeNum: number;
}

interface PriceGapChartProps {
  priceGapChartData: PriceGapDataPoint[];
}

export default function PriceGapChart({
  priceGapChartData,
}: PriceGapChartProps) {
  return (
    <div className="card">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-xl font-bold">PRICE GAP ANALYSIS</h2>
          <p className="text-sm text-gray-400 mt-1">
            Difference between Polymarket price and sportsbook implied probability - Edge detection
          </p>
        </div>
        <div className="flex gap-2">
          <span className="px-2 py-1 text-xs rounded bg-green-500/20 text-green-400 border border-green-500/30">
            +3% = Edge
          </span>
          <span className="px-2 py-1 text-xs rounded bg-red-500/20 text-red-400 border border-red-500/30">
            -3% = Reverse Edge
          </span>
        </div>
      </div>
      <div className="h-48">
        {priceGapChartData.length > 0 ? (
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={priceGapChartData}>
              <XAxis
                dataKey="time"
                stroke="#6b7280"
                tick={{ fontSize: 11 }}
              />
              <YAxis
                stroke="#6b7280"
                tick={{ fontSize: 11 }}
                domain={[-10, 10]}
                tickFormatter={(v) => `${v > 0 ? '+' : ''}${v}%`}
                label={{ value: 'Gap %', angle: -90, position: 'insideLeft', fill: '#6b7280', fontSize: 11 }}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: '#1a1a2e',
                  border: '1px solid #374151',
                  borderRadius: '8px',
                }}
                formatter={(value: number, name: string) => [
                  `${value > 0 ? '+' : ''}${value.toFixed(2)}%`,
                  name === 'gap' ? 'Price Gap' : name
                ]}
              />
              <ReferenceLine y={0} stroke="#6b7280" strokeWidth={1} />
              <ReferenceLine y={3} stroke="#22c55e" strokeDasharray="3 3" label={{ value: 'Edge Threshold', fill: '#22c55e', fontSize: 9 }} />
              <ReferenceLine y={-3} stroke="#ef4444" strokeDasharray="3 3" label={{ value: 'Reverse Edge', fill: '#ef4444', fontSize: 9 }} />
              <Area
                type="monotone"
                dataKey="gap"
                name="Price Gap"
                stroke="#06b6d4"
                fill="#06b6d4"
                fillOpacity={0.3}
                strokeWidth={2}
              />
            </ComposedChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-full flex items-center justify-center text-gray-400">
            <div className="text-center">
              <div className="text-4xl mb-2">📉</div>
              <div>Insufficient data for gap analysis</div>
              <div className="text-xs text-gray-500 mt-1">Need both Polymarket and Odds data</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
